
import React from 'react';
import './Card.css';

interface Props {
  title?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  noPad?: boolean;
}

export default function Card({ title, actions, children, footer, className = '', noPad }: Props) {
  return (
    <div className={`card ${className}`}>
      {(title || actions) && (
        <div className="card__header">
          {title && <span className="card__title">{title}</span>}
          {actions && <div className="card__actions">{actions}</div>}
        </div>
      )}
      <div className={`card__body${noPad ? ' card__body--nopad' : ''}`}>
        {children}
      </div>
      {footer && <div className="card__footer">{footer}</div>}
    </div>
  );
}
